import styled from 'styled-components'

import Avatar from '../Avatar'
import ActionButton from '../ActionButton'

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 7rem 11.2rem 5rem 7rem;
  background-color: ${({ theme }) => theme.colors.blueBack};

  ${({ theme }) => theme.breakpoints.down('tablet')} {
    padding: 3rem 3rem;
    gap: 2rem;
  }

  ${({ theme }) => theme.breakpoints.down('mobile')} {
    flex-direction: column;
  }
`

export const InfoWrapper = styled.div`
  display: flex;
  gap: 3rem;
  flex: 1;

  ${({ theme }) => theme.breakpoints.down('tablet')} {
    gap: 2rem;
    flex-direction: column;
  }
`
export const InfoBlock = styled.div`
  ${({ theme }) => theme.breakpoints.up('mobile')} {
    max-width: 29.3rem;
  }
`

export const Name = styled.p`
  ${({ theme }) => theme.textStyles.montserratTextBaseBold}
  color: ${({ theme }) => theme.colors.bluePrimary};
`

export const Role = styled.p`
  ${({ theme }) => theme.textStyles.montserratTextBase}
  color: ${({ theme }) => theme.colors.bluePrimary};
`

export const DashedBorder = styled.span`
  display: inline-block;
  width: 100%;
  border-bottom: 3px dashed ${({ theme }) => theme.colors.greyContour};
  margin: 1.2rem 0;
`

export const Description = styled.p`
  ${({ theme }) => theme.textStyles.montserratSm}
  color: ${({ theme }) => theme.colors.blueSecondaryBis};
`

export const AvatarStyled = styled(Avatar)`
  align-items: flex-start;
  width: 6rem;
  height: 6rem;

  ${({ theme }) => theme.breakpoints.up('tablet')} {
    width: 10rem;
    height: 10rem;
  }

  & img {
    width: 100%;
  }
`

export const Button = styled(ActionButton)`
  margin-top: 4rem;

  ${({ theme }) => theme.breakpoints.down('tablet')} {
    margin-top: 2rem;
  }
`
